'use client'

import { useTranslations } from 'next-intl'
import Image from 'next/image'

/**
 * Full-screen notice shown while MAINTENANCE_MODE=true (src/proxy.ts rewrites
 * every page here). Deliberately self-contained — no auth, no data fetching —
 * so it renders even while /api/auth/* is returning 503.
 */
export default function MaintenancePage() {
	const t = useTranslations()

	return (
		<div className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-6 bg-brand-dark px-6 text-center">
			<Image src="/logos/logo.png" alt="Chance" width={160} height={43} className="h-10 w-auto" />
			<h1 className="font-semibold text-2xl text-white">{t('maintenance.title')}</h1>
			<p className="max-w-md text-base text-brand-muted">{t('maintenance.description')}</p>
			<p className="max-w-md text-brand-muted text-sm">{t('maintenance.fundsSafe')}</p>
		</div>
	)
}
